module.exports = __webpack_public_path__ + "static/media/aemet_inst_pos_rgb.10be3b8e.png";